import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { LoaderService } from '@app/infrastructure/api-services/loader.service';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { HeaderComponent } from '../components/header/header.component';
import { SidebarComponent } from '../components/sidebar/sidebar.component';

@Component({
  standalone: true,
  selector: 'app-shell',
  imports: [
    RouterOutlet,
    RouterModule,

    // Zorro Modules
    NzLayoutModule,
    NzSpinModule,
    NzIconModule,
    NzResultModule,
    NzSpinModule,
    NzIconModule,

    // Components
    HeaderComponent,
    SidebarComponent,

    // Pipes
    AsyncPipe,
  ],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {
  isCollapsed = false;
  isLoading$ = this._loaderService.loading$;

  constructor(private readonly _loaderService: LoaderService) {}

  // Type guard method to check if a menu item has children
  hasChildren(item: any): boolean {
    return !!item.child && item.child.length > 0;
  }
}
